import { map, compact, fromPairs } from "lodash";
import { productClient } from "crossdock/base/Clients";

export async function getProductsBarcodesMap(dskus: string[]): Promise<Record<string, string[]>> {
  const products = compact(await Promise.all(dskus.map(async (dsku) => await productClient.getProductAuth0(dsku))));
  const dskuToProductBarcodes = fromPairs(map(products, ({ dsku, barcodes }) => [dsku, barcodes ?? []]));
  return dskuToProductBarcodes;
}
